
import { useDispatch, useSelector } from "react-redux";
import { useProcessedCVsPolling } from "./useProcessedCVsPolling";
import { useFetchJobs } from "./useFetchJobs";
import { useFetchCVsLabels } from "./useFetchCVLabels";


const useJobsData = () => {
  const jobs = useSelector((state) => state.jobs.jobs)
  const jobMatchingStatus = useSelector((state) => state.jobs.jobMatchingStatus)
  const candidates = useSelector((state) => state.jobs.candidates)
  const userId = useSelector((state) => state.auth.user.id)

  const { data: fetchedJobs, isFetching } = useFetchJobs({ userId, enabled: !jobs });

  return {
    jobs: jobs ?? fetchedJobs,
    jobMatchingStatus,
    candidates,
    isFetching,
  }
}

export const useData = ({ limit, offset }) => {
  const { jobs, jobMatchingStatus, candidates, isFetching: isFetchingJobs } = useJobsData();

  const {
    cvs,
    pendingCVs,
    pagination,
    isFetching: isFetchingCVs,
  } = useProcessedCVsPolling({ limit, offset });

  const storedLabels = useSelector((state) => state.cv.labels);
  const { data: labels, refetch: refetchLabels } = useFetchCVsLabels({
    enabled: !storedLabels,
    callback: () => {},
  });

  return {
    cvs,
    labels,
    refetchLabels,
    jobs: Object.values(jobs ?? {}),
    jobMatchingStatus,
    candidates: Object.values(candidates ?? {}),
    pendingCVs,
    pagination,
    isFetching: isFetchingJobs || isFetchingCVs,
    isFetchingCVs,
    isFetchingJobs
  }
}